import styled, { css } from "styled-components";

import { getMobileBreakpoint } from "manifest-components/src/Styles/globals";
import { ColorValues } from "manifest-components/src/Colors";

export const welcomeScreenBreakpoint = 950;

export const pehpContainer = css`
  max-width: 330px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: ${welcomeScreenBreakpoint}px) {
    max-width: 1220px;
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const IconAndContentSection = styled.div`
  padding-top: 20px;
  > * {
    display: flex;
    align-items: flex-start;
    &:not(:last-child) {
      margin-bottom: 32px;
    }
    > *:first-child {
      margin-right: 20px;
      box-shadow: 12px 12px 15px rgba(0, 0, 0, 0.06);
    }
    & *:last-child {
      flex: 1;
    }
    svg {
      width: 53px;
      height: 53px;
    }
  }
  @media (max-width: ${getMobileBreakpoint}) {
    padding-top: 0px;
    padding: 40px 0;
  }

  @media (min-width: 1024px) {
    padding: 40px 0;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 0;

    > * {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const ActionsContainer = styled.div`
  margin-top: 60px;
  margin-left: 61px;
  margin-right: 61px;
  text-align: center;
  button {
    margin-bottom: 30px;
  }
  @media (max-width: ${getMobileBreakpoint}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const WelcomeScreen = styled.div`
  .carouselContainer {
    height: 600px;
  }
  .welcomeScreenContent {
    margin-left: 60px;
    max-width: 600px;
  }
  @media (max-width: 1200px) {
    .headerContent,
    .footer,
    .welcomeScreenContentContainer {
      padding-left: 30px;
      padding-right: 30px;
    }
  }
  @media (max-width: ${getMobileBreakpoint}) {
    .welcomeScreenContent {
      margin-left: auto;
      margin-right: auto;
    }
    .headerContent,
    .footer,
    .welcomeScreenContentContainer {
      padding-left: 0px;
      padding-right: 0px;
      height: auto;
    }
  }
`;

export const NewPageLayout = styled.div`
  width: 100vw;
  overflow-x: hidden;
  .white-space-nowrap {
    white-space: nowrap !important;
    font-weight: 500 !important;
  }
  .pehp__description.bold {
    font-weight: 500 !important;
    line-height: 30px;
  }

  @media (min-width: 950px) {
    .pehp__description.with-padding {
      padding-right: 30px;
    }
    .pehp-launch-button {
      max-width: 487px;
    }
  }

  h1 {
    font-size: 28px;
    line-height: 1.35;
    font-weight: 500;
    margin-bottom: 24px;
    span {
      white-space: nowrap;
    }
  }
  h2 {
    font-size: 24px;
    line-height: 1.5;
    font-weight: 500;
    margin-bottom: 12px;
  }

  @media (min-width: ${welcomeScreenBreakpoint}px) {
    h1 {
      font-size: 40px;
    }
    h2 {
      font-size: 30px;
    }
    .welcomeScreenContentContainer {
      display: flex;
      width: 100%;
      padding-left: 40px;
      max-width: 1220px;
      min-height: 420px;
      margin-bottom: 100px;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const NewPageLayoutHeroSection = styled.div`
  max-width: 330px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: ${welcomeScreenBreakpoint}px) {
    padding-right: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    margin-left: 0;
    margin-right: auto;
    max-width: 573px;
    .with-padding {
      padding-right: 50px;
    }
    p,
    button {
      max-width: 600px;
    }
  }
`;

export const WelcomePageCarouselDiv = styled.div`
  padding-top: 40px;
  margin-top: 0;
  padding-bottom: 40px;
  @media (min-width: ${welcomeScreenBreakpoint}px) {
    padding-top: 0px;
    padding-bottom: 0;
    width: 420px;
  }
`;

export const WelcomePageLogoCarouselDiv = styled.div`
  width: 100vw;
  background: #132a27;
  padding: 28px 0;

  h2 {
    font-size: 18px;
    line-height: 26px;
    color: white;
    font-weight: 500;
    text-align: center;
    margin-bottom: 26px;
  }

  .logo-carousel-div {
    width: 100vw;
    overflow: hidden;
  }

  @media (min-width: ${welcomeScreenBreakpoint}px) {
    h2 {
      font-size: 20px;
    }
  }
`;

export const WelcomeSection = styled.div<{ $maxWidth?: number }>`
  margin-top: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${pehpContainer};

  @media (min-width: ${welcomeScreenBreakpoint}px) {
    max-width: ${(props) => (props.$maxWidth ? `${props.$maxWidth}px` : `1220px`)};
    margin-top: 90px;
  }
`;

export const WelcomeFullWidthSection = styled.div`
  margin-top: 55px;
  width: 100vw;
  @media (min-width: ${welcomeScreenBreakpoint}px) {
    margin-top: 90px;
  }
`;

export const WelcomeHowItWorks = styled(WelcomeSection)`
  display: flex;
  width: 100%;
  flex-direction: column;
  @media (min-width: ${welcomeScreenBreakpoint}px) {
    flex-direction: row;
    align-items: stretch;

    .content-div {
      max-width: 487px;
      padding-right: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .description {
        flex: 1;
      }
    }
    .list-div {
      margin-left: auto;
      max-width: 487px;
      padding-bottom: 0;
    }
  }
`;

export const WelcomeBackgrounded = styled.div`
  width: 100%;
  border-radius: 8px;
  background: ${ColorValues.orange};
  padding: 28px 22px;
  align-items: center;
  display: flex;
  flex-direction: column;

  img {
    margin-top: 22px;
    width: 125px;
  }

  @media (min-width: ${welcomeScreenBreakpoint}px) {
    height: 320px;
    flex-direction: row;
    padding: 0 80px;
    padding-right: 130px;

    &.row-reverse {
      flex-direction: row-reverse;
      .section__image {
        justify-content: flex-start;
        padding-left: 42px;
      }
    }
    .section__content {
      flex: 1;
      max-width: 540px;
      h2 {
        margin-bottom: 34px;
      }
    }

    .section__image {
      width: auto;

      &.section__image__plant {
        img {
          width: 220px;
          height: 249px;
          margin-left: 120px;
        }
      }
      &.section__image__soc {
        img {
          width: 194px;
          height: 193px;
          margin-right: 138px;
        }
      }
    }
  }
`;

export const TolstoyPopup = styled.div`
  height: 200px;

  @media screen and (min-width: 951px) {
    height: 330px;
  }
  > div {
    display: flex;
    iframe {
      border: none;
      width: 300px;
      height: 156px;
    }
    @media screen and (min-width: 951px) {
      iframe {
        width: 550px;
        height: 310px;
      }
    }
  }
`;
